export const Shorts = () => {
    return (
        <div>
            <h1 className="text-3xl text-slate-100 font-bold">Shorts</h1>
        </div>
    )
}